import * as types from '../mutations'
import APP from '../../constants'

export default {
  /**
   *
   */

}
